import React, { useState } from "react";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

const AccordionList = ({ list }) => {

    // Ensure list is valid to prevent errors
    if (!list || list.length === 0) {
        return <p>No items available</p>;
    }

    // Track which items are open

    
    return (
        // <Accordion>
        //     {list?.map((item, index) => (
        //         <AccordionItem key={index}>
        //             <AccordionItemHeading>
        //                 <AccordionItemButton>
        //                     <div className="app-description app-accordion-title" dangerouslySetInnerHTML={{ __html: item?.title }} />
        //                 </AccordionItemButton>
        //             </AccordionItemHeading>
        //             <AccordionItemPanel>
        //                 <div className="app-description mt-0" dangerouslySetInnerHTML={{ __html: item?.description }} />
        //             </AccordionItemPanel>
        //         </AccordionItem>
        //     ))}
        // </Accordion>
        <Accordion allowMultipleExpanded allowZeroExpanded>
      {list?.map((item, index) => (
        <AccordionItem key={index} uuid={index}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <div
                className="app-description "
                dangerouslySetInnerHTML={{ __html: item?.title }}
              />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="py-0 px-2">
            <div
              className="app-description mt-0 py-0"
              dangerouslySetInnerHTML={{ __html: item?.description }}
            />
          </AccordionItemPanel>
        </AccordionItem>
      ))}
    </Accordion>
    )
}

export default AccordionList;